import { postMessageUp } from 'iframe-support'
import _ from 'lodash'
import store from '../stores/configureStore'

export default {
  sessionTimerOverlayRenderedHook() {
    postMessageUp({ statusMessage: 'sessionTimerOverlayRendered' })
  },

  previewPageSendSubmitHook() {
    postMessageUp({ statusMessage: 'previewPageSendAction' })
  },

  noCurrencyBalanceErrorHook() {
    postMessageUp({
      statusMessage: 'noCurrencyBalanceError',
      toggleLoading: false,
    })
  },

  successPageAfterRenderHook() {
    let state = store.getState()
    let status = _.get(state, 'transaction.complianceInfo.status')
    let paymentId = _.get(state, 'transaction.paymentDetails.payment_id')
    if (status !== 'PENDING') {
      postMessageUp({
        statusMessage: 'successPageRendered',
        data: {
          amount: state.amount.amount,
          paymentId,
          currency: state.amount.currencyCode,
          amountFormatted: state.amount.amountFormatted,
          note: state.note.note,
        },
      })
    }
  },

  loadingStateChangedHook({ isLoading }) {
    postMessageUp({ toggleLoading: isLoading })
  },
}
